// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ClientsUserFormModal_buttons__2Zk1D","delete":"ClientsUserFormModal_delete__1Ugb6"};